import React from "react";
import ReactEcharts from "echarts-for-react";

// Function to calculate the linear regression (y = mx + b)
const getLinearTrend = (data) => {
  const n = data.length;
  const x = Array.from({ length: n }, (_, i) => i + 1); // Index as x-axis values
  const y = data;

  // Calculate the sum of x, y, x^2, and xy
  const sumX = x.reduce((acc, val) => acc + val, 0);
  const sumY = y.reduce((acc, val) => acc + val, 0);
  const sumXY = x.reduce((acc, val, idx) => acc + val * y[idx], 0);
  const sumX2 = x.reduce((acc, val) => acc + val * val, 0);

  // Calculate the slope (m) and intercept (b)
  const m = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX * sumX);
  const b = (sumY - m * sumX) / n;

  // Calculate the trend line values (y = mx + b) for each x
  const trendLine = x.map((val) => m * val + b);
  return trendLine;
};

const CashFlowIndi2 = () => {
  const dates = [
    "Nov-19", "Dec-19", "Jan-20", "Feb-20", "Mar-20", "Apr-20", "May-20", "Jun-20",
    "Jul-20", "Aug-20", "Sep-20", "Oct-20", "Nov-20", "Dec-20", "Jan-21", "Feb-21",
    "Mar-21", "Apr-21", "May-21", "Jun-21", "Jul-21", "Aug-21", "Sep-21", "Oct-21",
    "Nov-21", "Dec-21", "Jan-22", "Feb-22", "Mar-22", "Apr-22", "May-22", "Jun-22",
    "Jul-22", "Aug-22", "Sep-22", "Oct-22", "Nov-22", "Dec-22", "Jan-23", "Feb-23",
    "Mar-23", "Apr-23", "May-23", "Jun-23", "Jul-23", "Aug-23", "Sep-23", "Oct-23",
    "Nov-23", "Dec-23", "Jan-24", "Feb-24", "Mar-24", "Apr-24", "May-24", "Jun-24",
    "Jul-24", "Aug-24", "Sep-24", "Oct-24"
  ];

  const currentRatio = [
    0.82, 1.12, 1.16, 2.57, 2.79, 2.15, 2.46, 2.33, 1.69, 2.51, 3.01, 2.79, 3.86,
    9.06, 9.84, 7.06, 3.58, 6.69, -9.20, 5.72, 5.46, 5.79, 5.22, 8.33, 2.93, 4.04,
    3.02, 3.68, 3.18, 2.89, 2.77, 2.58, 2.53, 1.86, 1.74, 1.82, 1.74, 1.54, 1.37,
    1.38, 1.56, 1.42, 1.44, 1.30, 1.40, 1.29, 1.33, 1.41, 1.51, 1.55, 1.61, 1.58,
    1.57, 1.83, 1.80, 1.66, 1.66, 1.81, 2.20, 1.95
  ];

  // Calculate the trend line for currentRatio
  const trendLineCurrentRatio = getLinearTrend(currentRatio);

  const option = {
    tooltip: { trigger: "axis" },
    legend: { data: ["Current Ratio", "Trend Line (Current)"] },
    xAxis: {
      type: "category",
      data: dates,
      axisLabel: {
        rotate: 45, // Rotate labels to fit better
      },
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: "{value}",
      },
    },
    series: [
      {
        name: "Current Ratio",
        type: "line",
        data: currentRatio,
        smooth: true,
        lineStyle: { color: "blue" },
        markPoint: {
          data: [{ type: "max", name: "Max Value" }, { type: "min", name: "Min Value" }],
        },
      },
      {
        name: "Trend Line (Current)",
        type: "line",
        data: trendLineCurrentRatio,
        smooth: true,
        lineStyle: { type: "dashed", color: "blue" },
      },
    ],
  };

  return <ReactEcharts option={option} style={{ height: "500px" }} />;
};

export default CashFlowIndi2;
